module.exports = __webpack_public_path__ + "static/media/relaxation-m.069ba362.svg";